/**
 * Turns what an operator typed into the JSON value a mapping stores.
 *
 * A number only when the text round-trips through `Number` unchanged. `Number()` accepts a postal code, a
 * business number or an EIN written with a leading zero and silently drops it, so `"02134"` would be stored
 * as `2134`. On a default value that reaches FBO as the wrong identifier; on a value-mapping row it is worse,
 * because the row then never matches and the field is dropped without a word.
 *
 * Callers that accept booleans pass `withBooleans`. The default-value field does not: `null` there means
 * "no default", and a blank is how an operator clears it.
 */
export function parseMappingValue(value: string, withBooleans: true): string | number | boolean
export function parseMappingValue(value: string, withBooleans?: false): string | number | null
export function parseMappingValue(value: string, withBooleans = false): string | number | boolean | null {
  const trimmed = value.trim()

  if (trimmed === "") {
    return withBooleans ? value : null
  }

  const asNumber = Number(trimmed)
  if (!isNaN(asNumber) && String(asNumber) === trimmed) {
    return asNumber
  }

  if (withBooleans) {
    if (value.toLowerCase() === "true") return true
    if (value.toLowerCase() === "false") return false
  }

  return value
}
